<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText" [isClickable]="true"></app-input-label>

<input
  [id]="id"
  [name]="name"
  class="form-check-input"
  type="checkbox"
  [checked]="value"
  (blur)="onTouched($event)"
  (change)="handleInput()"
>

